<template>
  <div class="mt90">
    <el-row class="pr-bgimg pr-bg-case"></el-row>
    <el-row class="pr-container bg-white mt-160 pb-6">
      <h2 class="page-title">经典案例</h2>
      <p class="page-sub-title">Cases</p>
      <div class="pr-case-list pt-5 px-5 clear mw-img100">
        <el-col :span="8">
          <div @click="toCaseDetail(1)">
            <span><img src="../../assets/images/case/1482133754612.jpg"/></span>
            <h5>云旅通</h5>
          </div>
        </el-col>
        <el-col :span="8">
          <div @click="toCaseDetail(3)">
            <span><img src="../../assets/images/case/1482134136667.jpg"/></span>
            <h5>深圳文化产权交易所</h5>
          </div>
        </el-col>
        <el-col :span="8">
          <div @click="toCaseDetail(4)">
            <span><img src="../../assets/images/case/1482134804985.jpg"/></span>
            <h5>爱思拓</h5>
          </div>
        </el-col>
        <el-col :span="8">
          <div @click="toCaseDetail(5)">
            <span><img src="../../assets/images/case/1482135314156.jpg"/></span>
            <h5>大数据风控平台</h5>
          </div>
        </el-col>
        <el-col :span="8">
          <div @click="toCaseDetail(6)">
            <span><img src="../../assets/images/case/1482133948355.jpg"/></span>
            <h5>消费金融核心系统</h5>
          </div>
        </el-col>
        <el-col :span="8">
          <div @click="toCaseDetail(7)">
            <span><img src="../../assets/images/case/1482133948357.jpg"/></span>
            <h5>普惠金融核心系统整合</h5>
          </div>
        </el-col>
      </div>
    </el-row>
    <!-- 案例只有一个图片的弹窗 -->
    <el-dialog
    class="model-case-dialog"
    title="案例详情"
    top="5vh"
    :visible.sync="showCaseDialog"
    width="1200px">
      <el-row>
        <div v-if="dialogType == 2" class="mw-img100 text-center">
          <img src="../../assets/images/case/detail/4.png">
        </div>
        <div v-if="dialogType == 7" class="mw-img100 text-center">
          <img src="../../assets/images/case/detail/17.jpg">
        </div>
      </el-row>
    </el-dialog>
    <!-- ending -->
  </div>
</template>

<script>
export default {
  name: 'TypicalCase',
  data() {
    return {
      showCaseDialog: false,
      dialogType: null
    }
  },
  methods: {
    toCaseDetail(num) {
      if([2, 7].includes(num)) {
        this.showCaseDialog = true;
        this.dialogType = num;
        return
      }
      let jumpUrl  = this.$router.resolve( {path: '/case/detail/' + num} );
      window.open(jumpUrl.href, '_blank');
    }
  }
}
</script>

<style lang="scss">
.pr-bg-case {
  background-image: url('../../assets/images/case/1481880194517.jpg');
}
.pr-case-list {
  > .el-col {
    padding: 0 30px;
    margin-bottom: 50px;
    div{
      cursor: pointer;
      span{
        display: block;
        width: 312px;
        height: 202px;
        overflow: hidden;
        img {
          width: 312px;
          height: 202px;
          transition: all 0.6s;
          &:hover {
            transform: scale(1.1);
          }
        }
      }
      h5 {
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        margin: 10px 0;
      }
    }
    &:hover {
      color: #213752;
    }
  }
}
</style>
